import { useQuery } from '@tanstack/react-query';
import { useAuthorizedAxios } from '../../../core/hooks';
import { isValidCustomerId } from '../../../customers';
import { L3ServiceViewModel, mapL3ServicesApiToViewModel } from '../../../l3-services/model';
import { getL3ServiceDetails } from '../../api';
import { L3ServiceLocationsHttpQuery } from '../../config';

export interface L3ServiceLocationsApiGetHookResult {
  l3Service: L3ServiceViewModel | null;
  isFetching: boolean;
  isFetched: boolean;
}

export const useL3ServiceDetailsApiGet = (customerId: number, itemId: number): L3ServiceLocationsApiGetHookResult => {
  const axios = useAuthorizedAxios();
  const { data, isFetching, isFetched } = useQuery({
    queryKey: [L3ServiceLocationsHttpQuery['GetL3ServiceDetails'].key, customerId, itemId],
    queryFn: async () => {
      const apiL3ServiceLocationDetails = await getL3ServiceDetails(axios, { customerId, itemId });
      return mapL3ServicesApiToViewModel([apiL3ServiceLocationDetails])?.[0] || null;
    },
    enabled: isValidCustomerId(customerId),
    gcTime: 30000,
    staleTime: 1000,
    structuralSharing: false
  });
  return {
    isFetched,
    isFetching,
    l3Service: data || null
  };
};